import { useMemo, useState } from 'react';
import mcafeeLogo from '../../assets/mcafee_logo.png';
import axios from 'axios';
const openStaticEulaInNewTab = () => {
	const newTab = window.open('about:blank', '_blank');
	if (newTab) {
		newTab.focus();
		fetch('/qtnet-eula-static.html')
			.then((response) => response.text())
			.then((html) => {
				newTab.document.open();
				newTab.document.write(html);
				newTab.document.close();
			})
			.catch(() => {
				newTab.document.open();
				newTab.document.write('<html><body><p>Failed to load content.</p></body></html>');
				newTab.document.close();
			});
	}
};

export default function QtNetHandler() {
	const [lastName, setLastName] = useState('');
	const [firstName, setFirstName] = useState('');
	const [connectionId, setConnectionId] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [submitError, setSubmitError] = useState('');
	const [submitSuccess, setSubmitSuccess] = useState('');

	const isEnglishUi = () => {
		const htmlLang = (document.documentElement.lang || '').toLowerCase();
		const culture = (new URLSearchParams(window.location.search).get('culture') || '').toLowerCase();

		if (htmlLang) {
			return htmlLang.startsWith('en');
		}

		if (culture) {
			return culture.startsWith('en');
		}

		return false;
	};

	const setLocalizedValidationMessage = (event) => {
		const input = event.target;
		const english = isEnglishUi();

		if (input.validity.valueMissing) {
			input.setCustomValidity(english ? 'Please fill in this field.' : 'この項目は必須です。');
			return;
		}

		if (input.validity.typeMismatch && input.type === 'email') {
			input.setCustomValidity(english ? 'Please enter a valid email address.' : '正しいメールアドレスを入力してください。');
			return;
		}

		input.setCustomValidity(english ? 'Please check this field.' : '入力内容を確認してください。');
	};

	const clearValidationMessage = (event) => {
		event.target.setCustomValidity('');
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		setSubmitError('');
		setSubmitSuccess('');
		setIsSubmitting(true);

		try {
			const baseUrl = process.env.REACT_APP_PARTNER_PAGES_BACKEND_URL;
			const responseText = await axios.post(`${baseUrl}/qtnet/createsubscription`, {
				connectionId,
				password,
				emailAddress: email,
				firstName,
				lastName,
			}, {
				headers: {
					"Content-Type": "application/json"
			},
			});
			if(responseText.data?.data?.code !== 0) {
				setSubmitError('パートナー認証に失敗しました。');
			} else {
				const addSubscriptionUrl = `${process.env.REACT_APP_QTNET_ADD_SUBSCRIPTION_URL}`;
				window.location.assign(addSubscriptionUrl);
			}
		} catch (error) {
			setSubmitError('登録に失敗しました。時間をおいて再度お試しください。');
		} finally {
			setIsSubmitting(false);
		}
	};

		return (
		<div style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', fontFamily: '"Noto Sans JP", "Hiragino Kaku Gothic Pro", "Meiryo", sans-serif', color: '#1a1a1a' }}>
			<style>{`
				.qtnet-container {
					max-width: 980px;
					margin: 0 auto;
					padding: 0 20px;
				}
				.qtnet-header {
					background: #fff;
					color: #1a1a1a;
					padding: 12px 0;
				}
				.qtnet-header-inner {
					display: flex;
					align-items: center;
					gap: 16px;
				}
				.qtnet-header-left {
					display: flex;
					align-items: center;
					gap: 16px;
				}
				.qtnet-header-right {
					display: flex;
					flex-direction: column;
					align-items: flex-end;
					gap: 6px;
					margin-left: auto;
					position: relative;
				}
				.qtnet-mcafee-logo {
					height: 26px;
				}
				.qtnet-partner-logo {
					height: 34px;
				}
				.qtnet-account-link {
					color: #1a1a1a;
					text-decoration: none;
					font-size: 14px;
				}
				.qtnet-account-button {
					color: #1a1a1a;
					background: transparent;
					border: 1px solid #d7d7d7;
					border-radius: 4px;
					padding: 6px 10px;
					font-size: 13px;
					cursor: pointer;
				}
				.qtnet-account-menu {
					display: none;
					position: absolute;
					top: 100%;
					right: 0;
					background: #fff;
					border: 1px solid #d7d7d7;
					border-radius: 4px;
					min-width: 320px;
					padding: 6px 0;
					box-shadow: 0 6px 18px rgba(0,0,0,0.08);
					z-index: 10;
				}
				.qtnet-account-menu-item {
					display: block;
					padding: 10px 12px;
					font-size: 13px;
					color: #1a1a1a;
					text-decoration: none;
				}
				.qtnet-account-menu-item:hover {
					background: #f5f5f5;
					color: #c01818;
				}
				.qtnet-header-right:hover .qtnet-account-menu,
				.qtnet-header-right:focus-within .qtnet-account-menu {
					display: block;
				}
				.qtnet-main {
					padding: 36px 0 48px;
				}
				.qtnet-card {
					background: #fff;
					border-radius: 6px;
					box-shadow: 0 6px 18px rgba(0,0,0,0.08);
					padding: 28px;
				}
				.qtnet-title {
					font-size: 24px;
					font-weight: 700;
					margin-bottom: 6px;
				}
				.qtnet-subtitle {
					font-size: 14px;
					color: #666;
					margin-bottom: 18px;
				}
				.qtnet-required {
					color: #000;
					font-size: 12px;
					margin-left: 6px;
				}
				.qtnet-form {
					display: grid;
					gap: 16px;
				}
				.qtnet-field {
					display: grid;
					gap: 8px;
				}
				.qtnet-member-info {
					display: grid;
					gap: 12px;
					margin-top: 8px;
					margin-bottom: 8px;
				}
				.qtnet-section-title {
					font-size: 16px;
					font-weight: 700;
					padding-bottom: 4px;
					border-bottom: 1px solid #d7d7d7;
				}
				.qtnet-label {
					font-size: 13px;
					font-weight: 600;
				}
				.qtnet-inline-field {
					display: grid;
					grid-template-columns: 1fr;
					align-items: stretch;
					gap: 8px;
				}
				.qtnet-inline-field .qtnet-label {
					margin: 0;
				}
				.qtnet-label-row {
					display: flex;
					align-items: center;
					gap: 10px;
					flex-wrap: wrap;
				}
				.qtnet-inline-input-wrap {
					display: grid;
					gap: 6px;
				}
				.qtnet-email-help {
					background-color: #eeeeee;
					color: #333333;
					padding: 4px 10px;
					border-radius: 4px;
					font-size: 12px;
					font-weight: 600;
					line-height: 1.4;
				}
				.qtnet-input {
					border: 1px solid #d7d7d7;
					border-radius: 4px;
					padding: 10px 12px;
					font-size: 14px;
					background: #fff;
				}
				.qtnet-row {
					display: grid;
					grid-template-columns: 1fr 1fr;
					gap: 12px;
				}
				.qtnet-note {
					font-size: 12px;
					color: #666;
					line-height: 1.6;
				}
				.qtnet-privacy {
					color: #0b5bd3;
					text-decoration: none;
				}
				.qtnet-privacy:hover {
					color: #c01818;
				}
				.qtnet-inline-link {
					color: #0b5bd3;
					background: none;
					border: none;
					padding: 0;
					font: inherit;
					line-height: inherit;
					text-decoration: underline;
					cursor: pointer;
				}
				.qtnet-inline-link:hover {
					color: #c01818;
				}
				.qtnet-button {
					background: #c01818;
					color: #fff;
					border: none;
					border-radius: 4px;
					padding: 14px 18px;
					font-size: 14px;
					font-weight: 700;
					cursor: pointer;
					width: 100%;
				}
				.qtnet-footer {
					text-align: center;
					color: #777;
					font-size: 12px;
					padding: 24px 0 36px;
				}
				@media (max-width: 640px) {
					.qtnet-row {
						grid-template-columns: 1fr;
					}
					.qtnet-card {
						padding: 20px;
					}
				}
			`}</style>

			<header className="qtnet-header">
				<div className="qtnet-container qtnet-header-inner">
					<div className="qtnet-header-left">
						<img
							className="qtnet-mcafee-logo"
							src={mcafeeLogo}
							alt="McAfee"
						/>
					</div>
					<div className="qtnet-header-right">
						<img
							className="qtnet-partner-logo"
							src="https://secureimages.mcafee.com/common/affiliateImages/qtnet/logo_white.png"
							alt="QTNET"
						/>
						<button
							type="button"
							className="qtnet-account-button"
						>
							マイ アカウント
						</button>
						<div className="qtnet-account-menu">
							<a className="qtnet-account-menu-item" href="https://home.mcafee.com/Secure/MyAccount/DashBoard.aspx">
								マカフィー製品と サービス
							</a>
							<a className="qtnet-account-menu-item" href="https://www.mcafee.com/en-gb/consumer-support/policy/legal/gdpr-data-request.html">
								マカフィーが保管する情報
							</a>
						</div>
					</div>
				</div>
			</header>

			<main className="qtnet-main">
				<div className="qtnet-container">
					<div className="qtnet-card">
						<div className="qtnet-title">BBIQトータルセキュリティ ユーザー登録</div>
						<div className="qtnet-subtitle">
							以下の項目を入力して、「BBIQトータルセキュリティ ユーザー登録」ボタンを押して下さい。
							<span className="qtnet-required">※全項目入力必須</span>
						</div>

						<form className="qtnet-form" onSubmit={handleSubmit}>
							<div className="qtnet-field">
								<label className="qtnet-label">お申し込み者名＜ご利用者名＞</label>
								<div className="qtnet-row">
									<input
										className="qtnet-input"
										type="text"
										placeholder="姓"
										aria-label="姓"
										value={lastName}
										onChange={(event) => setLastName(event.target.value)}
										onInvalid={setLocalizedValidationMessage}
										onInput={clearValidationMessage}
										required
									/>
									<input
										className="qtnet-input"
										type="text"
										placeholder="名"
										aria-label="名"
										value={firstName}
										onChange={(event) => setFirstName(event.target.value)}
										onInvalid={setLocalizedValidationMessage}
										onInput={clearValidationMessage}
										required
									/>
								</div>
							</div>

							<div className="qtnet-member-info">
								<div className="qtnet-section-title">BBIQ 会員情報</div>

								<div className="qtnet-inline-field">
									<label className="qtnet-label" htmlFor="qtnet-connection-id">接続ID（半角）:</label>
									<input
										id="qtnet-connection-id"
										className="qtnet-input"
										type="text"
										value={connectionId}
										onChange={(event) => setConnectionId(event.target.value)}
										onInvalid={setLocalizedValidationMessage}
										onInput={clearValidationMessage}
										required
									/>
								</div>

								<div className="qtnet-inline-field">
									<div className="qtnet-label-row">
										<label className="qtnet-label" htmlFor="qtnet-email">BBIQ メールアドレス（半角）:</label>
										<div className="qtnet-email-help">
											次に表示される画面でこのメールアドレスを使用してパスワードのリセットを行ってください。
										</div>
									</div>
									<div className="qtnet-inline-input-wrap">
										<input
											id="qtnet-email"
											className="qtnet-input"
											type="email"
											value={email}
											onChange={(event) => setEmail(event.target.value)}
											onInvalid={setLocalizedValidationMessage}
											onInput={clearValidationMessage}
											required
										/>
									</div>
								</div>

								<div className="qtnet-inline-field">
									<label className="qtnet-label" htmlFor="qtnet-password">接続パスワード（半角）:</label>
									<input
										id="qtnet-password"
										className="qtnet-input"
										type="password"
										value={password}
										onChange={(event) => setPassword(event.target.value)}
										onInvalid={setLocalizedValidationMessage}
										onInput={clearValidationMessage}
										required
									/>
								</div>
							</div>

							<div className="qtnet-note">
								お客様の同意を得ずに、お客様情報を共有することはありません。{' '}
								<a className="qtnet-privacy" href="https://www.mcafee.com/ja-jp/consumer-support/policy/legal.html" target="_blank" rel="noreferrer">
									プライバシーポリシーを表示
								</a>
							</div>

							<hr style={{ border: 'none', borderTop: '1px solid #d7d7d7', margin: '4px 0 0' }} />

							<div className="qtnet-note">
								下の「BBIQトータルセキュリティ ユーザー登録」をクリックすると、
								<button
									type="button"
									className="qtnet-inline-link"
									onClick={openStaticEulaInNewTab}
								>
									McAfee 使用許諾契約書を確認し、同意したものとみなされます。
								</button>
							</div>

							{submitError ? <div className="qtnet-note" style={{ color: '#c01818' }}>{submitError}</div> : null}
							{submitSuccess ? <div className="qtnet-note" style={{ color: '#0b7a28' }}>{submitSuccess}</div> : null}

							<button type="submit" className="qtnet-button">
								{isSubmitting ? '送信中...' : 'BBIQトータルセキュリティ ユーザー登録'}
							</button>
						</form>
					</div>
				</div>
			</main>

			<footer className="qtnet-footer">© 2003-2026 McAfee, LLC</footer>
		</div>
	);
}
